'use client';

import { c as _c } from "react/compiler-runtime";
import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';

/**
 * Returns a ref that always holds the latest value, updated in the post-commit
 * phase via a no-dependency `useEffect`. This ensures callbacks and effects
 * that read the ref always see the most recent value without triggering
 * re-renders or violating React Compiler ref-write rules.
 *
 * Equivalent to:
 * ```ts
 * const ref = useRef(value);
 * useEffect(() => { ref.current = value; });
 * ```
 */
export function useSyncRef(value) {
  const $ = _c(2);
  const ref = useRef(value);
  let t0;
  if ($[0] !== value) {
    t0 = () => {
      ref.current = value;
    };
    $[0] = value;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(t0);
  return ref;
}